'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z' });

var Replay = function Replay(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Replay = (0, _pure2.default)(Replay);
Replay.muiName = 'SvgIcon';

exports.default = Replay;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Replay.js
// module id = 2770
// module chunks = 0